/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { EducationEnum } from './educationEnum';
import { ExtendedGenderEnum } from './extendedGenderEnum';
import { LengthOfPracticeEnum } from './lengthOfPracticeEnum';
import { NullEnum } from './nullEnum';
import { OccupationEnum } from './occupationEnum';
import { PreferredLanguageEnum } from './preferredLanguageEnum';
import { RegionEnum } from './regionEnum';
import { RegistrationSourceEnum } from './registrationSourceEnum';
import { TeacherRegistrationOrganization } from './teacherRegistrationOrganization';

/**
 * Register new parent data.
 */
export interface TeacherRegister { 
    firstName?: string;
    lastName?: string;
    email: string;
    phone?: string;
    password: string;
    generalTipsVersion?: string;
    generalTipsConsent?: boolean;
    contractKeyword?: string;
    contractVersion?: string;
    contractConsent: boolean;
    captchaToken?: string;
    activationCode?: string;
    preferredLanguage?: PreferredLanguageEnum;
    nickname?: string;
    gender?: ExtendedGenderEnum;
    invitationId?: string;
    registrationSource?: RegistrationSourceEnum | NullEnum;
    lengthOfPractice?: LengthOfPracticeEnum;
    region?: RegionEnum;
    education?: EducationEnum;
    occupation?: OccupationEnum;
    organization?: TeacherRegistrationOrganization;
    verificationLink?: string;
}